import { theme } from 'antd';

const { getDesignToken } = theme;

export const AUTH_DATA_STORAGE_KEY = 'authStorageKey';

export const IS_ASTERI_LK = import.meta.env.VITE_COMPANY_NAME === 'Asteri'; // TODO: Придумать как затипизировать

export const dateFormat = 'DD/MM/YYYY';
export const NOTIFICATION_DEFAULT_DURATION_IN_SECONDS = 5;

// export const SELFIE_ID = '43c84dac-9069-11ef-bafa-000c29d99558';
export const EMPTY_VALUE = '—';

// из этого токена можно получить значение цвета тема внутри tsx файлов
export const globalThemeToken = getDesignToken();
export const appTheme = {
  token: {
    // fontSize: 16,
    //   fontFamily: 'Noto Sans, sans-serif',
    fontFamily: 'Manrope',
    colorPrimary: '#455baf',
    colorText: '#252525',
    colorTextPlaceholder: 'rgba(0, 0, 0, 0.4)',
    //   colorBgBase: '#fff',
    //   colorBgContainer: '#fff',
    //   // colorTextBase: '#203b54',
    //   colorTextSecondary: '#4d6276',
    //   controlHeight: 40,
    //   colorBorder: '#adadad',
  },
};
